<script>
import VBaseCard from "@/components/commonComponents/VBaseCard.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "VBaseCardAjaxList",
    components: {
        AjaxLoad,
        VBaseCard,
    },
    props: {
        heading: {
            type: String,
        },
        url: {
            type: String,
            required: true,
        },
        transform: {
            type: Function,
            default: response => response.data.data.items,
        },
    },
}
</script>

<template>
    <ajax-load
        :url="url"
        :transform="transform"
        v-slot="{data, resolved}"
    >
        <v-base-card
            :loading="!resolved"
            :heading="heading"
            hide-filter
            hide-search
        >
            <v-list>
                <v-list-item-group
                    v-if="resolved"
                >
                    <template v-for="item in data">
                        <slot v-bind="{item}"></slot>
                    </template>
                </v-list-item-group>
                <v-skeleton-loader
                    v-else
                    type="list-item-avatar"
                ></v-skeleton-loader>
            </v-list>
        </v-base-card>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
